;(function () {
	var canvas = document.getElementById( 'frm-signature' );

	canvas.width = canvas.closest( '.form-field' ).clientWidth;

	const signatureDataField = canvas.closest( 'div' ).querySelector( 'input' );

	var signaturePad = new SignaturePad(canvas, {
		onEnd: function ( e ) {
			signatureDataField.value = signaturePad.toDataURL();
		}
	});

	if ( signatureDataField.value ) {
		signaturePad.fromDataURL( signatureDataField.value );
	}

	canvas.parentNode.querySelector( 'button' )
		.addEventListener( 'click', e => {
			e.preventDefault();
			signaturePad.clear();
		});

	const initialFields = document.querySelectorAll( '.initial-form-field' );

	initialFields.forEach( field => {
		const cnvs = field.querySelector( 'canvas' );
		const input = field.querySelector( 'input[type="hidden"]' );
		const pad = new SignaturePad( cnvs, {
			onEnd: function ( e ) {
				input.value = pad.toDataURL();
			}
		});
		field.querySelector( 'button' )
			.addEventListener( 'click', e => {
				e.preventDefault();
				input.value = '';
				pad.clear();
			});
	});

	var form = canvas.closest( 'form' );

	form.querySelector( '[type="submit"]' ).addEventListener( 'click', function ( e ) {
		e.preventDefault();

		if ( ! form.checkValidity() ) {
			form.reportValidity();
		} else if ( signaturePad.isEmpty() ) {
			jQuery( canvas ).parent().find( '.error-message' ).remove();
			showErrorMessage( 'Signature is required.', canvas );
			jQuery( canvas ).parent().find( '.error-message' )[0].scrollIntoView();
		} else {
			if ( window.grecaptcha ) {
				window.grecaptcha.execute();
			} else {
				form.submit();
			}
		}
	});

	function showErrorMessage( message, element ) {
		const errorElement = document.createElement( 'span' );
		const errorMessage = document.createTextNode( message );
		errorElement.appendChild( errorMessage );
		errorElement.classList.add( 'error-message' );
		element.insertAdjacentElement(
			'beforebegin',
			errorElement
		);
	}
}());

